/**
 * Play a short, pleasant "pin" / chime using Web Audio API.
 * No external audio asset needed.
 *
 * Respects a localStorage mute flag (`execSoundEnabled`, default true).
 */
let _audioCtx = null;

function getCtx() {
  if (_audioCtx) return _audioCtx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _audioCtx = new AC();
    return _audioCtx;
  } catch {
    return null;
  }
}

export function isSoundEnabled() {
  try {
    const v = localStorage.getItem('execSoundEnabled');
    return v === null ? true : v === 'true';
  } catch {
    return true;
  }
}

export function setSoundEnabled(enabled) {
  try {
    localStorage.setItem('execSoundEnabled', enabled ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

export function playPin(kind = 'success') {
  if (!isSoundEnabled()) return;
  const ctx = getCtx();
  if (!ctx) return;

  // Some browsers suspend the context until a user gesture.
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }

  const now = ctx.currentTime;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  // Success = bright ascending chime; failure = soft descending tone.
  if (kind === 'failure') {
    osc.type = 'sine';
    osc.frequency.setValueAtTime(520, now);
    osc.frequency.exponentialRampToValueAtTime(320, now + 0.25);
  } else {
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, now); // A5
    osc.frequency.exponentialRampToValueAtTime(1320, now + 0.09); // E6
  }

  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.18, now + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.32);

  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(now);
  osc.stop(now + 0.34);
}
